<template>
    <Message v-if="isFreeTryPlan" severity="info" :closable="false">
        <div class="flex flex-row items-center justify-between gap-2">
            <span>{{ t('banner.free_try_plan_message') }}</span>
            <PlanSwitchButton size="small" />
        </div>
    </Message>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTenantsStore } from '@/stores/tenants'
import { TenantPlan } from '@/models/Tenant'
import Message from 'primevue/message'

const { t } = useI18n()
const tenantsStore = useTenantsStore()

const isFreeTryPlan = computed(() => {
    return tenantsStore.currentTenant?.plan === TenantPlan.FREE_TRY
})
</script>
